/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import CustomerNotice from '../containers/customer/CustomerNotice';
import CustomerFaq from '../containers/customer/CustomerFaq';
import CustomerQna from '../containers/customer/CustomerQna';
import CustomerUse from '../containers/customer/CustomerUse';
import Footer from '../components/Footer';

import { Helmet } from 'react-helmet-async';

class Join extends Component {
  state = {
    tabIndex: 1,
  };
  componentDidMount = () => {
    const { match } = this.props;
    let index = match.params.index;
    ////console.log(match)
    //console.log(index)
    if (index === '' || index === null || index === undefined) {
      index = 1;
    }

    setTimeout(() => {
      this.setState({
        tabIndex: parseInt(index),
      });
    }, 500);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    // return false 하면 업데이트를 안함
    const { match } = this.props;
    ////console.log(nextProps)
    ////console.log(this.state)
    ////console.log(nextProps.pro)
    return match.params.index !== nextProps.match.params.index;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //const { match } = this.props;
    ////console.log(nextProps)

    let index = nextProps.match.params.index;
    ////console.log(match)
    //console.log(index)
    if (index === '' || index === null || index === undefined) {
      index = 0;
    }

    setTimeout(() => {
      this.setState({
        tabIndex: parseInt(index),
      });
    }, 500);
  };
  _onChangeTab = (tabIndex) => {
    const { history } = this.props;
    history.push('/customer/' + tabIndex);
  };
  render() {
    const { tabIndex } = this.state;
    return (
      <Fragment>
        <Helmet>
          <title>고객센터 - 애니플러스</title>
          <meta name="title" content="고객센터 - 애니플러스" />
          <meta
            name="description"
            content="가장 빠른 라이브 방영 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="고객센터, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션, "
          />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="고객센터 - 애니플러스" />
          <meta
            property="og:description"
            content="고객센터 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta
            property="og:url"
            content="https://www.aniplustv.com/customer/1"
          />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="고객센터 - 애니플러스" />
          <meta
            name="twitter:description"
            content="고객센터 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta
            name="twitter:domain"
            content="https://www.aniplustv.com/customer/1"
          />

          <link rel="canonical" href="https://www.aniplustv.com/customer/1" />
        </Helmet>
        <div className="content" style={{ position: 'relative' }}>
          <div
            className={
              tabIndex === 1
                ? 'service_div customer01'
                : tabIndex === 2
                ? 'service_div customer02'
                : tabIndex === 3
                ? 'service_div customer03'
                : 'service_div customer04'
            }
          >
            <h1 className="customer">고객센터</h1>
            <div className="service_group">
              <div className="service_tab">
                <div>
                  <a
                    className={tabIndex === 1 ? 'on' : null}
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._onChangeTab(1)}
                  >
                    공지사항
                  </a>
                  <a
                    className={tabIndex === 2 ? 'on' : null}
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._onChangeTab(2)}
                  >
                    자주 묻는 질문
                  </a>
                  <a
                    className={tabIndex === 3 ? 'on' : null}
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._onChangeTab(3)}
                  >
                    1:1문의
                  </a>
                  <a
                    className={tabIndex === 4 || tabIndex === 5 ? 'on' : null}
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._onChangeTab(4)}
                  >
                    이용약관 및 개인정보 처리방침
                  </a>
                </div>
              </div>

              {tabIndex === 1 ? (
                <CustomerNotice tabIndex={tabIndex} />
              ) : tabIndex === 2 ? (
                <CustomerFaq />
              ) : tabIndex === 3 ? (
                <CustomerQna />
              ) : tabIndex === 4 || tabIndex === 5 ? (
                <CustomerUse />
              ) : null}
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Join));
